module.exports = {"330481001":"硖石街道","330481002":"海洲街道","330481003":"海昌街道","330481004":"马桥街道","330481101":"许村镇","330481103":"长安镇","330481105":"周王庙镇","330481106":"丁桥镇","330481107":"斜桥镇","330481108":"黄湾镇","330481110":"盐官镇","330481112":"袁花镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330481.json
// module id = 904
// module chunks = 0